import { Stack, Typography } from "@mui/material";
import { useContext } from "react";
import { useQuery } from "react-query";
import API from "../../services/API";
import UserContext from "../../services/Context/UserContext";
import producers from "../../config/producers";
import Card from "../Courses/Card";
import { txt } from "../../services/translation";

export function Masterclass() {
    const { user } = useContext(UserContext);
    const isLearnyLib = user?.siret?.toString() === producers[0].siret;

    const { data: courses } = useQuery({
        queryKey: ['masterclass', 'dentaire'],
        queryFn: async () => {
            const { data } = await API.get('/courses');
            return data.filter((c) => 
                c.kind?.id === 'masterclass' && c.category?.id === 'dentaire'
            );
        },
        enabled: isLearnyLib,
    });

    if (!isLearnyLib || !courses || courses?.length === 0) return <></>;

    return (
        <Stack gap={2}>
            <Typography variant="h1">{txt('ourMasterclass')}</Typography>
            <Stack direction="row" flexWrap="wrap">
                {courses.map((course) => <Card key={course.id} course={course} />)}
            </Stack>
        </Stack>
    );
}
